export class ReverseUrlRoutingError extends Error {
    constructor(message: string, cause?: Error) {
        super(`Could not generate URL route: ${message}`, cause ? {cause} : undefined);
    }
}

export class UrlParsingError extends Error {
    constructor(message: string, cause?: Error) {
        super(`Could not parse URL: ${message}`, cause ? {cause} : undefined);
    }
}
